<template>
  <div>
    <el-dialog
      title="反馈记录"
      :visible.sync="visible"
      width="820px"
      top="5vh"
      :close-on-click-modal="false"
      custom-class="feedback-history-dialog"
      @open="onOpen"
      @closed="onClosed"
    >
      <el-table
        :data="tableData"
        border
        size="small"
        height="420"
        v-loading="loading"
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column prop="feedback_type" label="类型" width="110" align="center">
          <template slot-scope="scope">
            {{ typeText(scope.row.feedback_type) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="处理状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="statusTagType(scope.row.status)" size="mini">
              {{ statusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="shop_name" label="相关店铺" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.shop_name || "--" }}
          </template>
        </el-table-column>
        <el-table-column prop="content" label="描述" min-width="180" show-overflow-tooltip />
        <el-table-column prop="create_time" label="提交时间" width="160">
          <template slot-scope="scope">
            {{ formatTime(scope.row.create_time) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="70" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="feedback-history-pager">
        <el-pagination
          @current-change="loadList"
          @size-change="changeSize"
          :current-page.sync="page"
          background
          layout="total, prev, pager, next, sizes"
          :page-size="pageSize"
          :total="total"
          :page-sizes="[10, 20, 50]"
        />
      </div>
    </el-dialog>

    <el-dialog
      title="反馈详情"
      :visible.sync="detailVisible"
      width="640px"
      top="8vh"
      append-to-body
      :close-on-click-modal="false"
      @closed="onDetailClosed"
    >
      <div v-loading="detailLoading" class="feedback-detail">
        <div class="feedback-detail__status">
          <span class="feedback-detail__status-label">处理状态</span>
          <el-tag :type="statusTagType(detail.status)" size="small">
            {{ statusText(detail.status) }}
          </el-tag>
        </div>

        <el-descriptions :column="2" border size="small" class="mgb12">
          <el-descriptions-item label="类型">{{ typeText(detail.feedback_type) }}</el-descriptions-item>
          <el-descriptions-item label="提交时间">{{ formatTime(detail.create_time) }}</el-descriptions-item>
          <el-descriptions-item label="相关店铺" :span="2">
            {{ detail.shop_name || "--" }}
          </el-descriptions-item>
          <el-descriptions-item label="描述" :span="2">
            <div class="feedback-detail__content">{{ detail.content || "--" }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="链接1" :span="2">{{ detail.link1 || "--" }}</el-descriptions-item>
          <el-descriptions-item label="链接2" :span="2">{{ detail.link2 || "--" }}</el-descriptions-item>
          <el-descriptions-item label="链接3" :span="2">{{ detail.link3 || "--" }}</el-descriptions-item>
          <el-descriptions-item label="处理备注" :span="2">
            {{ detail.admin_remark || "暂无" }}
          </el-descriptions-item>
        </el-descriptions>

        <div v-if="imageList.length" class="feedback-detail__images-block">
          <div class="feedback-detail__images-title">截图</div>
          <div class="feedback-detail__images">
            <el-image
              v-for="(url, idx) in imageList"
              :key="idx"
              :src="url"
              :preview-src-list="imageList"
              fit="cover"
              class="feedback-detail__image"
            />
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "FeedbackHistoryDialog",
  data() {
    return {
      visible: false,
      loading: false,
      tableData: [],
      page: 1,
      pageSize: 20,
      total: 0,
      detailVisible: false,
      detailLoading: false,
      detail: {},
    };
  },
  computed: {
    imageList() {
      const raw = this.detail && this.detail.images;
      if (!raw) return [];
      if (Array.isArray(raw)) return raw.filter(Boolean);
      try {
        const arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr.filter(Boolean) : [];
      } catch (e) {
        return String(raw)
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
      }
    },
  },
  methods: {
    open() {
      this.visible = true;
    },
    onOpen() {
      this.page = 1;
      this.loadList();
    },
    onClosed() {
      this.tableData = [];
      this.total = 0;
      this.detailVisible = false;
      this.detail = {};
    },
    onDetailClosed() {
      this.detail = {};
    },
    typeText(t) {
      if (t == 1) return "软件缺陷反馈";
      if (t == 2) return "新功能建议";
      return "--";
    },
    statusText(s) {
      if (s == 0) return "待处理";
      if (s == 1) return "处理中";
      if (s == 2) return "已处理";
      return "--";
    },
    statusTagType(s) {
      if (s == 0) return "danger";
      if (s == 1) return "warning";
      if (s == 2) return "success";
      return "info";
    },
    formatTime(ts) {
      const n = Number(ts);
      if (!n) return "--";
      const d = new Date(n * 1000);
      if (Number.isNaN(d.getTime())) return "--";
      const pad = (x) => (x < 10 ? "0" + x : "" + x);
      return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes()) +
        ":" +
        pad(d.getSeconds())
      );
    },
    changeSize(v) {
      this.pageSize = v;
      this.page = 1;
      this.loadList();
    },
    async loadList() {
      this.loading = true;
      try {
        const res = await this.$api.post("/admintooluserfeedback/mylist", {
          page: this.page,
          pageSize: this.pageSize,
        });
        if (res && res.code == 1) {
          this.tableData = res.list || [];
          this.total = parseInt((res.pageInfo && res.pageInfo.total) || 0, 10) || 0;
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.error((res && res.msg) || "加载失败");
        }
      } catch (e) {
        this.tableData = [];
        this.total = 0;
        this.$message.error("加载失败");
      } finally {
        this.loading = false;
      }
    },
    async openDetail(row) {
      if (!row || !row.id) return;
      this.detailVisible = true;
      this.detailLoading = true;
      this.detail = {};
      try {
        const res = await this.$api.post("/admintooluserfeedback/mydetail", {
          id: row.id,
        });
        if (res && res.code == 1 && res.detail) {
          this.detail = res.detail;
        } else {
          this.$message.error((res && res.msg) || "加载详情失败");
          this.detailVisible = false;
        }
      } catch (e) {
        this.$message.error("加载详情失败");
        this.detailVisible = false;
      } finally {
        this.detailLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.feedback-history-pager {
  margin-top: 12px;
  text-align: center;
}
.feedback-detail__status {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
  padding: 10px 12px;
  background: #f5f7fa;
  border-radius: 4px;
}
.feedback-detail__status-label {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
}
.feedback-detail__content {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.5;
}
.mgb12 {
  margin-bottom: 12px;
}
.feedback-detail__images-block {
  margin-top: 4px;
}
.feedback-detail__images-title {
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
}
.feedback-detail__images {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.feedback-detail__image {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}
</style>
